<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/>
<circle cx="8.5" cy="11.5" r="2" stroke="currentColor" stroke-width="1.6"/>
<path d="M5.5 16.3c.6-1.6 1.8-2.5 3-2.5s2.4.9 3 2.5M13.5 10h5M13.5 13h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
</svg>
</template>
